import { gql } from '@apollo/client';

export const GET_ACCOUNT_FAVORITE_LIST = gql`
query {
    getCustomerFavoriteAccounts 
  }
`;

export default GET_ACCOUNT_FAVORITE_LIST;